import {
  FamilyHistory,
  PatientFamilyHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

type Params = {
  familyHistory: FamilyHistory;
  xTENANTID?: string;
};

/**
 * @author Rajkumar Rathod
 */
export const usePastFamilyHistoryUpdate = () =>
  useMutationWithLoading(async (params: Params) =>
    new PatientFamilyHistoryControllerApi(
      getConfigObject()
    ).updatePatientFamilyHistory(params.familyHistory, params.xTENANTID)
  );
